import React from "react";

const ShopNameSVG = ({ shopName,colour }) => {
  // Splitting shop name into two words
  const words = shopName.split(" ");
  const firstLine = words[0] || "";
  const secondLine = words.slice(1).join(" ") || ""; // Handles multi-word second line

  return (
    <svg width="75" height="70" viewBox="0 0 190 70" xmlns="http://www.w3.org/2000/svg">
      <text 
        x="50%" 
        y="30%" 
        dominantBaseline="middle" 
        textAnchor="middle" 
        fontSize="42" 
        fill={colour}
        fontFamily="TenorSans-Regular"
      >
        {firstLine.toUpperCase()}
      </text>
      <text 
        x="50%" 
        y="80%" 
        dominantBaseline="middle" 
        textAnchor="middle" 
        fontSize="25" 
        fill={colour}
        fontFamily="TenorSans-Regular"
      >
        {secondLine.toUpperCase()}
      </text>
    </svg>
  );
};

export default ShopNameSVG;
